import './App.css';
import List from './List';

function App() {
  const handleVideoEnd = (event) => {
    // Pause the video and freeze on the last frame
    event.target.pause();
  };

  return (
    <div className="App">
      <header className="App-header">
        {/* Video Section */}
        <video
          src="Logray Ultimate Logo.mp4"
          autoPlay
          muted
          onEnded={handleVideoEnd}
          style={{ width: '40%', height: 'auto' }}
        ></video>

        {/* Text Content */}
        <p className="small-text">Version 1.3</p>
        <br></br>
        <p className="smaller-text">Not recommended for mobile devices.</p>
       <br></br>

      </header>
      <List />
    </div>
  );
}

export default App;
